import { icon, type IconName } from "../icons";
import { api, busy, cardHead, clear, fmtDay, h, toast, type Child } from "../lib";

type Summary = {
  users: number;
  today: { usd: number; n: number };
  month: { usd: number; n: number };
  cap: number;
  list: { email: string; created_at: string; credits: number; cuts: number }[];
};

const won = (usd: number) => `약 ${Math.round(usd * 1400).toLocaleString()}원`;

export async function renderAdmin(main: HTMLElement) {
  let s = await api<Summary>("/api/admin/summary");
  const stats = h("div", { class: "stats" });
  const users = h("div", { class: "card" });

  const stat = (ic: IconName, label: string, big: string, ...extra: Child[]) =>
    h("div", { class: "card stat" }, h("div", { class: "stat-label" }, h("span", { class: "stat-icon" }, icon(ic, 18)), label), h("b", { class: "stat-num num" }, big), extra);

  function drawStats() {
    clear(stats);
    const pct = s.cap ? Math.min(100, Math.round((s.today.usd / s.cap) * 100)) : 0;
    stats.append(
      stat("users", "가입자", `${s.users}명`),
      stat(
        "coins",
        `오늘 생성 ${s.today.n}장`,
        `$${s.today.usd.toFixed(2)}`,
        h("span", { class: "small muted" }, won(s.today.usd)),
        h("div", { class: "meter", role: "meter", "aria-valuemin": "0", "aria-valuemax": String(s.cap), "aria-valuenow": s.today.usd.toFixed(2), "aria-label": "오늘 쓴 금액 / 하루 상한" }, h("span", { style: { width: `${pct}%` } })),
        h("span", { class: "xs muted" }, `하루 상한 $${s.cap} 중 ${pct}%`),
      ),
      stat("calendar", `이번 달 ${s.month.n}장`, `$${s.month.usd.toFixed(2)}`, h("span", { class: "small muted" }, won(s.month.usd))),
    );
  }

  function drawUsers() {
    clear(users);
    users.append(
      cardHead("가입자", { sub: `${s.list.length}명` }),
      h(
        "table",
        { class: "table hide-sm" },
        h("thead", null, h("tr", null, h("th", null, "이메일"), h("th", null, "가입"), h("th", { class: "r" }, "남은 크레딧"), h("th", { class: "r" }, "만든 컷"))),
        h(
          "tbody",
          null,
          s.list.map((u) => h("tr", null, h("td", null, u.email), h("td", { class: "num" }, fmtDay(u.created_at)), h("td", { class: "r num" }, String(u.credits)), h("td", { class: "r num" }, String(u.cuts)))),
        ),
      ),
      h(
        "ul",
        { class: "user-cards show-sm" },
        s.list.map((u) => h("li", null, h("b", { class: "one-line" }, u.email), h("span", { class: "xs muted num" }, `가입 ${fmtDay(u.created_at)} · 남은 ${u.credits} · 컷 ${u.cuts}`))),
      ),
    );
  }

  const email = h("input", { type: "email", placeholder: "가입한 이메일", required: true });
  const credits = h("input", { type: "number", value: "20", step: "1", inputmode: "numeric" });
  const note = h("input", { placeholder: "예: 시연용", maxlength: 200 });
  const btn = h("button", { class: "btn primary", type: "submit" }, "크레딧 주기");
  drawStats();
  drawUsers();
  main.append(
    h("div", { class: "page-head" }, h("h1", null, "운영")),
    stats,
    h(
      "form",
      {
        class: "card grant",
        onsubmit: async (e: Event) => {
          e.preventDefault();
          await busy(btn, "주는 중", async () => {
            const who = email.value;
            const r = await api<{ credits: number }>("/api/admin/grant", { body: { email: who, credits: Number(credits.value), note: note.value } });
            toast(`${who} 님 잔액 ${r.credits} 크레딧`, "ok");
            email.value = "";
            note.value = "";
            s = await api<Summary>("/api/admin/summary");
            drawStats();
            drawUsers();
          });
        },
      },
      cardHead("크레딧 주기"),
      h(
        "div",
        { class: "grant-row" },
        h("label", null, "이메일", email),
        h("label", null, "크레딧", h("div", { class: "input-suffix", "data-suffix": "크레딧" }, credits)),
        h("label", null, h("span", null, "메모 ", h("span", { class: "opt" }, "(선택)")), note),
        btn,
      ),
    ),
    users,
  );
}
